import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getRevenueList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.REVENUE}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async exportRevenueList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.REVENUE}/export/excel${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
